import { makeImgIng, getCanvasJson } from '@/api/affairs'
import { useSdkStore } from "@/stores/sdk";
const makeImgIngs = async () => {
    const urlParams = new URLSearchParams(window.location.search)
    const pk = urlParams.get('increment_id')
    if (!pk) {
        return
    }
    await makeImgIng({
        increment_id: pk,
    })
}
const getCanvasJsons = async () => {
    const urlParams = new URLSearchParams(window.location.search)
    const pk = urlParams.get('id') as string
    let res = await getCanvasJson({
        design_id: pk,
    })
    const sdkStore = useSdkStore();
    const sdk = sdkStore.getSdk()
    sdk.designOpt.setCanvasPreview(JSON.parse(res.data.data.data_json))

}
export const initDesign = () => {
    makeImgIngs()
    getCanvasJsons()
}
